/**
 * H5 PTT SDK 目标语 — 对齐 Android ClassRoomActivity.resolveCrV3TargetLanguages（D14）
 */

import { shortLangCode } from '../adapters/live-speech-adapter'

export interface ResolvePttTargetLanguagesInput {
  /** 用户 PTT 发言语种（join languageCode，可 BCP47） */
  pttSourceLanguageCode: string
  /** 课堂源语（session workLangCode，可 BCP47） */
  classroomWorkLangCode: string
  /** 听取目标语列表（session workLangListenCode 解析后的短码） */
  listenTargetLanguageCodes: string[]
}

/**
 * 参会者用听取语种之一发言时，SDK 需额外翻译为课堂源语 + 其他听取语种；
 * 用课堂源语发言时，仅翻译为全部听取语种。
 */
export function resolvePttTargetLanguages(input: ResolvePttTargetLanguagesInput): string[] {
  const pttShort = shortLangCode(input.pttSourceLanguageCode)
  const workShort = shortLangCode(input.classroomWorkLangCode)
  const listenTargets = dedupeShortCodes(input.listenTargetLanguageCodes)
  const defaultListen = listenTargets.length ? listenTargets : ['en']

  const isSourceLanguage = pttShort === workShort && Boolean(workShort)
  const isInTargetLanguages = defaultListen.some((code) => code === pttShort)

  if (isInTargetLanguages && !isSourceLanguage) {
    const targets: string[] = []
    if (workShort) {
      targets.push(workShort)
    }
    for (const code of defaultListen) {
      if (code !== pttShort && !targets.includes(code)) {
        targets.push(code)
      }
    }
    return targets.length ? targets : defaultListen
  }

  return defaultListen
}

function dedupeShortCodes(codes: string[]): string[] {
  const seen = new Set<string>()
  const result: string[] = []
  for (const code of codes) {
    const short = shortLangCode(code)
    if (!short || seen.has(short)) {
      continue
    }
    seen.add(short)
    result.push(short)
  }
  return result
}
